import { PUBLIC_CLOUDINARY_CLOUD_NAME } from "$app/env/public";

export function faviconCdnUrl(slug: string, pathname: string): string {
	const base = `https://res.cloudinary.com/${PUBLIC_CLOUDINARY_CLOUD_NAME}`;
	const filename = pathname.slice(1);

	if (pathname.endsWith(".ico")) {
		return `${base}/raw/upload/brand/${slug}/${filename}`;
	}

	const publicId = filename.replace(/\.png$/, "");
	return `${base}/image/upload/brand/${slug}/${publicId}`;
}
